import { Leaf } from "lucide-react";

export default function Marquee({ items }) {
    return (
        <section
            aria-hidden="true"
            data-testid="editorial-marquee"
            className="overflow-hidden border-y border-gold/20 bg-forest-deep py-5"
        >
            <div className="animate-marquee flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {items.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="whitespace-nowrap px-8 font-serif text-xl italic text-[#F9F6F0]/90 sm:text-2xl">
                                    {item}
                                </span>
                                <Leaf className="h-4 w-4 shrink-0 text-gold" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
